import React from 'react';
import EditorQuote from '@wix/da-ds/pkg/Icons/24x24/EditorQuote';
import EditorIconButton from '../_partials/EditorIconButton';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import { TOOLTIP_HOVER_DELAY } from '../../../constants';
const Blockquote = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'blockquote')) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "format:blockquote",
        icon: EditorQuote,
        onClick: ()=>editor.chain().focus().toggleBlockquote().run(),
        isActive: editor.isActive('blockquote'),
        tooltipHoverDelay: TOOLTIP_HOVER_DELAY,
        tooltipText: t('button.blockquote.tooltip'),
        "aria-label": t('button.blockquote.tooltip')
    });
};
Blockquote.displayName = 'Blockquote';
export default Blockquote;

//# sourceMappingURL=Blockquote.js.map